// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de la bolilla
 * @param {*} scene 
 */
export function cargaAssetsBolilla(scene) {
  scene.load.image(
    "bolillaFondoVerde",
    ROUTES.rutaRuletaBolilla + "/bolillaVerdeResized.png"
  );
  scene.load.image(
    "bolillaFondoRojo",
    ROUTES.rutaRuletaBolilla + "/bolillaRojoResized.png"
  );
  scene.load.image(
    "bolillaFondoNegro",
    ROUTES.rutaRuletaBolilla + "/bolillaNegroResized.png"
  );

  scene.load.spritesheet(
    "numerosBolillaMovimiento",
    ROUTES.rutaRuletaBolilla + "/numerosBolillaMovimientoResized-Sheet.png",
    {
      frameWidth: 84,
      frameHeight: 80,
    }
  );

  scene.load.spritesheet(
    "bolillaFondoVerdeMovimiento",
    ROUTES.rutaRuletaBolilla + "/bolillaVerdeMovimientoResized-Sheet.png",
    {
      frameWidth: 84,
      frameHeight: 80,
    }
  );

  scene.load.spritesheet(
    "bolillaFondoNegroMovimiento",
    ROUTES.rutaRuletaBolilla + "/bolillaNegroMovimientoResized-Sheet.png",
    {
      frameWidth: 84,
      frameHeight: 80,
    }
  );

  scene.load.spritesheet(
    "bolillaFondoRojoMovimiento",
    ROUTES.rutaRuletaBolilla + "/bolillaRojoMovimientoResized-Sheet.png",
    {
      frameWidth: 84,
      frameHeight: 80,
    }
  );

}